import React, { useState } from "react";
import { Modal, Typography, Button, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteComponent";
import { replaceEmployee } from "../../employeeDetails/employeeDetailsSlice";
import { useLocation, useParams } from "react-router-dom";

const { Title } = Typography;

const ReplaceEmployee = (props) => {
  const { visible, hide, record } = props;
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [replaceEmployees, setReplaceEmployees] = useState(false);
  const [replacePatients, setReplacePatients] = useState(false);
  const replaceLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/replace"]
  );
  const intl = useIntl();
  const dispatch = useDispatch();
  let { branchId } = useParams();
  let location = useLocation();

  const isAdmin = location.pathname.includes("admin");
  const staffFilter = { filter: { $and: [{ staff_member: true }] } };
  const onReplaceClicked = async () => {
    const params = {
      employeeId: record.id,
      branchId,
      replacementDetails: {
        new_staff_worker_id: selectedEmployee,
        replace_employees: replaceEmployees,
        replace_patients: replacePatients,
      },
    };
    const action = await dispatch(replaceEmployee(params));
    if (!action.error) {
      hide();
    }
  };

  const onHide = () => {
    setSelectedEmployee(null);
    setReplaceEmployees(false);
    setReplacePatients(false);
    hide();
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={onHide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: "0px 100px 40px 100px",
        },
      }}
      destroyOnClose={true}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onHide}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          {intl.formatMessage({
            id: "app.employees.replaceEmployeeTitle",
          })}
        </Title>
        <EmployeesSelect
          style={{ width: "200px", marginBottom: "20px" }}
          placeholder={intl.formatMessage({
            id: "app.employees.selectReplacement",
          })}
          onChange={(value) => setSelectedEmployee(value)}
          extraParams={{
            ...staffFilter,
            scopePrefix: isAdmin ? `` : `branches/${branchId}/`,
          }}
        />
        <Checkbox
          checked={replaceEmployees}
          onChange={(e) => setReplaceEmployees(e.target.checked)}
          style={{ marginBottom: "10px" }}
        >
          {intl.formatMessage({
            id: "app.employees.replaceEmployees",
          })}
        </Checkbox>
        <Checkbox
          checked={replacePatients}
          onChange={(e) => setReplacePatients(e.target.checked)}
          style={{ marginBottom: "20px" }}
        >
          {intl.formatMessage({
            id: "app.employees.replacePatients",
          })}
        </Checkbox>
        <Button
          style={{ width: "fit-content" }}
          type="primary"
          disabled={
            !selectedEmployee || (!replaceEmployees && !replacePatients)
          }
          onClick={onReplaceClicked}
          loading={replaceLoading}
        >
          {intl.formatMessage({
            id: "app.employees.replaceEmployee",
          })}
        </Button>
      </div>
    </Modal>
  );
};

export default ReplaceEmployee;
